// extracted by mini-css-extract-plugin
module.exports = {"termMini":"TitleBar_termMini__NOaj5","termMiniText":"TitleBar_termMiniText__mWe2E"};